
// React Imports
import * as React from "react";

// Mui Imports
import {Stack} from "@mui/material";


// App Imports
import WorkQueueBodyRight from "./WorkQueueBodyRight";
import WorkQueueBodyLeft from "./WorkQueueBodyLeft";
import {useSelector} from "react-redux";
import Box from "@mui/material/Box";
import ContractBigAddButtonPanel from "../Contracts/ContractBigAddButtonPanel";
import ContractSearchGrid from "../Contracts/ContractSearchGrid";
import ContractSearch from "../Contracts/ContractSearch";
import WorkStatsFrame from "../WorkStats/WorkStatsFrame";
import BulkEditGrid from "../BulkEdit/BulkEditGrid";
import WorkQueueCards from "../Cards/WorkQueueCards";
import WorkQueueCdpPanel from "../ContractDataPoints/WorkQueueCdpPanel";
import CdpvPivot from "../Pivot/CdpvPivot";


// main function
export default function WorkQueueBody(props) {


    const selectorPropertySearchState = useSelector((state) => state.workQueueSlc.value.propertySearchState);
    const selectorUnstructuredSearchState = useSelector((state) => state.workQueueSlc.value.unstructuredSearchState);
    const selectorStatsViewState = useSelector((state) => state.workQueueSlc.value.statsViewState);
    const selectorContractId = useSelector((state) => state.workQueueSlc.value.selectedContractId);
    const  selectorTitleId = useSelector((state) => state.workQueueSlc.value.propertyDropdownTitleId);
    const selectorSearchState = useSelector((state) => state.contractSearchSlc.value.searchState);
    const selectorBulkEditSearchState = useSelector((state) => state.workQueueSlc.value.bulkEditGridState);
    const selectorCardState = useSelector((state) => state.workQueueSlc.value.cardsState);
    const selectorExperience = useSelector((state) => state.workQueueSlc.value.workQueueExperience);
    const selectorBigAddButtonDisplay = useSelector((state) => state.workQueueSlc.value.bigAddButtonDisplay);

    // ****************** BEGIN RETURN ****************************

    return(
        <div>
            {/*{*/}
            {/*    ((selectorPropertySearchState === true || selectorUnstructuredSearchState === true) && selectorContractId === 0 && selectorTitleId === 0 ) &&*/}
                {selectorBigAddButtonDisplay &&
                <ContractBigAddButtonPanel/>
            }
            {
                (selectorExperience === "Friendly" && selectorContractId > 0 ) &&
                <WorkQueueCdpPanel/>
            }
            {(selectorUnstructuredSearchState === true && selectorSearchState === true) &&
                <div>
                    <Box
                        sx={{
                            height: 30
                        }}/>
                    <ContractSearch/>
                </div>
                }
            {
                ((selectorExperience === "ShowMe" || selectorExperience === null) &&  (selectorPropertySearchState === true || selectorUnstructuredSearchState === true)
                    && selectorBulkEditSearchState === false && selectorCardState === false) &&
                <div>
                    <Box
                        sx={{
                            height: 50
                        }}/>
            <Stack direction="row" spacing={2}>
            <WorkQueueBodyLeft/>
            <WorkQueueBodyRight/>
            </Stack>
                </div>
            }
            {selectorStatsViewState === true &&
                <div>
                    <Box
                        sx={{
                            height: 50
                        }}/>
                <WorkStatsFrame/>
                </div>
            }
            {selectorBulkEditSearchState && <BulkEditGrid/>}
            {(selectorCardState === true) && <WorkQueueCards/>}
            {/*<div>*/}
            {/*    <p>CARDS</p>*/}
            {/*            <WorkQueueCards/>*/}
            {/*</div>*/}
            {/*{selectorTitleId &&*/}
            {/*<CdpvPivot/>}*/}
            </div>
    )

    // ****************** END RETURN ****************************

}